var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./index.module.css";
import { File } from "./file";
import { ActionBar } from "./action-bar";
import { DeleteTreeNodePopup } from "@/04-features/delete-tree-node-popup";
import { RenameTreeNodePopup } from "@/04-features/rename-tree-node-popup";
import { getDocuments } from "@/06-shared/api";
import { useNotifyError } from "@/06-shared/lib/useNotifyError";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
export const Browser = ({ parentId = null, onDocumentsLoaded = () => { }, }) => {
    const [documents, setDocuments] = useState([]);
    const showError = useNotifyError();
    const navigate = useNavigate();
    const loadDocuments = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const loadedDocuments = yield getDocuments({ parentId });
            setDocuments(loadedDocuments);
            onDocumentsLoaded(loadedDocuments);
        }
        catch (error) {
            setDocuments([]);
            onDocumentsLoaded([]);
            showError(error);
        }
    });
    useEffect(() => {
        loadDocuments();
    }, [parentId]);
    return (_jsxs("div", Object.assign({ className: styles.browserContainer }, { children: [_jsx(ActionBar, { parentId: parentId, onProcessFinished: loadDocuments }), _jsxs("div", Object.assign({ className: styles.browserHeader }, { children: [_jsx("span", { children: "type" }), _jsx("span", { children: "name" }), _jsx("span", { children: "actions" })] })), _jsxs("div", Object.assign({ className: styles.fileList }, { children: [documents.length === 0 ? (_jsx("div", Object.assign({ className: styles.emptyState }, { children: _jsx("span", { children: "-- empty directory --" }) }))) : null, documents.map((document, idx) => {
                        return (_jsx(File, { name: document.title, type: document.type, onClick: () => navigate(`/${document.id}`), actions: _jsxs(_Fragment, { children: [_jsx(RenameTreeNodePopup, { document: document, onProcessFinished: loadDocuments }), _jsx(DeleteTreeNodePopup, { document: document, onProcessFinished: loadDocuments })] }) }, document.id));
                    })] }))] })));
};
